import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div className="bg-white text-gray-900">
      {/* Hero Section */}
      <header className="py-20 px-6 text-center bg-gradient-to-b from-gray-50 to-white">
        <h1 className="text-5xl font-extrabold tracking-tight mb-4">
          Your AI Career <span className="text-blue-600">Architect</span>
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
          Stop sending generic resumes. Use Gemini AI to tailor your CV for every job,
          generate professional DOCX files, and track your applications—all in one place.
        </p>
        <div className="flex justify-center gap-4">
          <Link to="/login" className="bg-blue-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-blue-700 transition">
            Get Started Free
          </Link>
          <a href="#features" className="border border-gray-300 px-8 py-3 rounded-lg font-bold hover:bg-gray-50 transition">
            See Features
          </a>
        </div>
      </header>

      {/* Features Grid */}
      <section id="features" className="py-20 max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <FeatureCard
            icon={<SparklesIcon className="text-blue-500" />}
            title="AI Rewriting"
            desc="Gemini-powered engine adapts your experience to match specific Job Descriptions."
          />
          <FeatureCard
            icon={<FileTextIcon className="text-green-500" />}
            title="Pro DOCX/PDF"
            desc="Generates pixel-perfect documents including your profile picture and custom branding."
          />
          <FeatureCard
            icon={<LayoutIcon className="text-purple-500" />}
            title="Custom Templates"
            desc="Upload your own format and let the AI fill in the details automatically."
          />
          <FeatureCard
            icon={<ListChecksIcon className="text-orange-500" />}
            title="Job Tracker"
            desc="Manage application statuses with a detailed history of your interview journey."
          />
        </div>
      </section>
    </div>
  );
};

// --- Standard SVG Components ---

const IconWrapper = ({ children, className }) => (
  <svg
    xmlns="http://www.w3.org"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {children}
  </svg>
);

const SparklesIcon = ({ className }) => (
  <IconWrapper className={className}>
    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
    <path d="M5 3v4" /><path d="M19 17v4" /><path d="M3 5h4" /><path d="M17 19h4" />
  </IconWrapper>
);

const FileTextIcon = ({ className }) => (
  <IconWrapper className={className}>
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4" /><path d="M10 9H8" /><path d="M16 13H8" /><path d="M16 17H8" />
  </IconWrapper>
);

const LayoutIcon = ({ className }) => (
  <IconWrapper className={className}>
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M3 9h18" /><path d="M9 21V9" />
  </IconWrapper>
);

const ListChecksIcon = ({ className }) => (
  <IconWrapper className={className}>
    <path d="m3 17 2 2 4-4" /><path d="m3 7 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" />
  </IconWrapper>
);

const FeatureCard = ({ icon, title, desc }) => (
  <div className="p-6 border border-gray-100 rounded-xl shadow-sm hover:shadow-md transition">
    <div className="mb-4">{icon}</div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-gray-600 text-sm">{desc}</p>
  </div>
);

export default LandingPage;
